import { token } from '@cp/shared/di';

const USER_STORAGE = token('user/STORAGE');
export const getUserStorageToken = <T = unknown>() => USER_STORAGE as ReturnType<typeof token<T>>;
